import { UndergradCourses } from '@/models/undergrad/undergrad-courses.model';

export interface UndergradCourseState {
  undergradCourses: { [key: string]: UndergradCourses };
  isSwitchingCurrentCourse: boolean;
  currentCourseId: string;
  isLoadingCourseLives: { [courseId: string]: boolean };
}

const state: UndergradCourseState = {
  undergradCourses: {},
  isSwitchingCurrentCourse: false,
  currentCourseId: '',
  isLoadingCourseLives: {},
};

export default state;
